import { ENTERPRISE_LINKS } from "../constants/constants";

/**
 * Determines the platform based on the current URL
 *
 * @returns {string} 'ENTERPRISE' or 'DEFAULT'
 */
export const getPlatformFromUrl = () => {
  if (typeof window === "undefined") return "DEFAULT";

  const hostname = (window.location.hostname || "").toLowerCase();

  if (hostname === "localhost" || hostname === "127.0.0.1") {
    const envPlatform = (process.env.REACT_APP_PLATFORM || "DEFAULT").toString().toUpperCase();
    return envPlatform === "ENTERPRISE" ? "ENTERPRISE" : "DEFAULT";
  }

  if (ENTERPRISE_LINKS.includes(hostname)) {
    return "ENTERPRISE";
  }

  return "DEFAULT";
};

export const isEnterprisePlatform = () => getPlatformFromUrl() === "ENTERPRISE";

export const isDevOrStageHost = () => {
  if (typeof window === "undefined") return false;
  const hostname = window.location.hostname || "";
  return ["localhost", "dev", "stage"].some((envToken) => hostname.includes(envToken));
};
